import moment from 'moment';

import {rison} from 'common/util/rison';
import {getReportBaseUrl, propertyFiltersToSegFilters, propertyToSegFilter} from './common';

const exports = {};
export default exports;

/* eslint-disable camelcase */
exports.generateParams = function({query, alertType, alertId, startStepIdx, shared}) {
  query = Object.assign({propertyFilters: []}, query);

  const urlParams = {
    conversion_unit: query.timeUnit.toLowerCase(),
  };

  // TODO(mack): Figure out how to handle timezones
  const currMoment = moment();
  urlParams.from_date = moment(query.dateRange.from).diff(currMoment, `days`);
  urlParams.to_date = moment(query.dateRange.to).diff(currMoment, `days`);

  const filters = propertyFiltersToSegFilters(query.propertyFilters);

  if (query.groupByProperty) {
    const groupByProperty = query.groupByProperty;
    const propertySegFilter = propertyToSegFilter(groupByProperty);
    filters.push(propertySegFilter);
    urlParams.segment_type = propertySegFilter.type;
  }

  urlParams.segfilter = {
    filters,
    op: `and`,
  };

  urlParams.smart_hub = {alert_type: alertType, alert_id: alertId}; // eslint-disable-line camelcase

  if (Number.isInteger(startStepIdx)) {
    urlParams.event_index = startStepIdx + 1; // eslint-disable-line camelcase
  }

  if (shared) {
    urlParams.shared = `smarthub`;
  }

  return urlParams;
};
/* eslint-enable camelcase */

// See FunnelsQuery in clj/service/smart-hub/protos/smart_hub.proto for the query format
exports.generatePermalink = function(
  {query, alertType, alertId, projectId, startStepIdx, shared, workspaceId},
  absolute = false,
) {
  const urlParams = exports.generateParams({
    query,
    alertType,
    alertId,
    startStepIdx,
    shared,
  });
  const urlHash = rison.urlencode(urlParams);
  let link = `${getReportBaseUrl({
    projectId,
    workspaceId,
  })}/funnels/#view/${query.bookmarkId}/${urlHash.substring(1, urlHash.length - 1)}`;
  if (absolute) {
    const rootURL = `${window.location.protocol}//${window.location.host}`;
    link = rootURL + link;
  }
  return link;
};
